<template>
    <rkm-area
        no-margin-top
        title="Exames solicitados"
    >
        <rkm-row>
            <rkm-col cols="12">
                <rkm-list
                    :items="item.plano.examesSolicitados"
                    hide-filters
                    hide-pagination
                >

                <template v-slot="{item}">
                        <rkm-row>
                            <rkm-col>
                                <Item
                                    :get-value="() => item.cidDescricao ?? '-'"
                                    label="CID 10"
                                />
                            </rkm-col>

                            <rkm-col>
                                <Item
                                    :get-value="() => item.ciapDescricao ?? '-'"
                                    label="CIAP 2"
                                />
                            </rkm-col>

                            <rkm-col>
                                <Item
                                    :get-value="() => item.justificativa"
                                    label="Justificativa do procedimento"
                                />
                            </rkm-col>

                            <rkm-col>
                                <Item
                                    :get-value="() => item.observacao"
                                    label="Observações"
                                />
                            </rkm-col>
                        </rkm-row>
                    </template>

                    <template v-slot:collapse="{item}">
                        <rkm-row class="p-2">
                            <rkm-col>
                                <rkm-table
                                    :fields="[{key: 'exame', label: 'Exame', sortable: true}]"
                                    :items="item.exames"
                                    hide-filters
                                    hide-pagination
                                >
                                    <template v-slot:cell(exame)="{item}">
                                        {{formatProcedimento(item.codigoProcedimento)}} - {{item.descricao}}
                                    </template>
                                </rkm-table>
                            </rkm-col>
                        </rkm-row>
                    </template>
                </rkm-list>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

// Mixins.
import {formats} from '@/mixins'

export default {
    components: {Item},
    mixins: [formats],
    props: {
        item: {type: Object, required: true},
    },
}
</script>